import { useReducer, useCallback } from 'react';
import constate from 'constate';
import _ from 'lodash';
const pageReducer = (state, action) => {
    switch (action.type) {
        case 'TOGGLE_NAV': {
            return Object.assign({}, state, { nav: Object.assign({}, state.nav, { collapsed: action.payload.collapsed }) });
        }
        default:
            return state;
    }
};
export const usePageContext = constate(() => {
    const [state, dispatch] = useReducer(pageReducer, {
        nav: {
            collapsed: false,
        },
    });
    const navActions = {
        toggle: useCallback((isOpen) => {
            const navCollapsed = _.isBoolean(isOpen) ? isOpen : !state.nav.collapsed;
            dispatch({ type: 'TOGGLE_NAV', payload: { collapsed: navCollapsed } });
        }, [dispatch, state.nav.collapsed]),
    };
    const actions = {
        navActions,
    };
    return [state, actions];
});
export const usePageNav = () => {
    const [{ nav }, { navActions }] = usePageContext();
    return [nav, navActions];
};
//# sourceMappingURL=PageContext.js.map